import storage from 'store'
import store from 'vx/store'
import router from '@/router'
import { includes } from 'lodash'

export default {
  /**
   * Get token from local storage.
   *
   * @return string
   */
  getToken () {
    return storage.get('token')
  },

  /**
   * Attempt authentication via the token.
   *
   * @return Promise
   */
  attemptViaToken () {
    const { auth } = store.state

    if (
      auth.user.id !== null &&
      auth.user.id !== undefined
    ) {
      return Promise.resolve()
    }

    let token = this.getToken()

    if (token === null || token === undefined) {
      throw new Error('Could not resolve token from local storage.')
    }

    return store.dispatch('auth/authorize')
  },

  /**
   * Redirect if token has expired.
   *
   * @return void
   */
  async redirectOnTokenExpired (to = null) {
    await this.logout()

    // if they are going to dashboard or login we don't need to add the path as
    // that's where they will go when they login normally anyway
    if (to && !includes(['login', 'dashboard'], to.name)) {
      router.push({ name: 'login', query: { redirect: to ? to.path : null } })
    } else {
      router.push({ name: 'login' })
    }
  },

  /**
   * Redirect to dashboard if a forbidden response is received.
   *
   * @return void
   */
  redirectOnForbidden () {
    router.push({ name: 'dashboard' })
  },

  /**
   * Update JWT from the authorization header of a response.
   *
   * @param string authorization
   *
   * @return void
   */
  updateTokenFromHeader (authorization) {
    storage.set('token', authorization.substring(7))
  },

  /**
   * Log the user out. Clear the storage token.
   *
   * @return void
   */
  async logout () {
    if (this.getToken()) {
      try {
        await store.dispatch('auth/deauthenticate')

        storage.remove('token')

        return true
      } catch (error) {
        return false
      }
    }

    return false
  }
}
